import React from "react";
import {
  Route,
  Routes,
  BrowserRouter,
  useLocation,
} from "react-router-dom";
import AsignarServicio from "./pages/AsignarServicio";
import Header from "./pages/Header";
import ActivityPage from "./pages/ActivityPage";
import Login from "./components/Login";
import Archivados from "./components/Archivados";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./context/ProtectedRoute";
import MainPage from "./pages/MainPage";
import CustomersTable from "./pages/CustomersTable";
import Tecnicos from "./pages/Tecnicos";
import AgendarServicio from "./pages/AgendarServicio";
import EditarSolicitud from "./pages/EditarSolicitud";
import ComponenteGantt from "./pages/DiagramaGantt";
import RegistroBonos from "./pages/RegistroBonos";
import GestorGastos from './pages/gestor/gestor_gastos';
import LogisticaGruas from "./pages/logisitca/LogisticaGruas";
import AptitudesTecnicos from './pages/Aptitudes';
import CompetenciasTecnicas from './pages/CompetenciasTecnicas';
import PanelControlInfo from "./pages/PanelControlInfo";
import EditarSolicitudSinAsignar from "./pages/EditarSolicitudSinAsignar";
import { ExtenderSolicitud } from "./pages/ExtenderSolicitud";
import OverviewChecadas from "./pages/overview/OverviewChecadas";
import ApartarTecnicoSinTicket from "./pages/ApartarTecnicoSinTicket";
import TicketBonosSearch from "./pages/TicketBonosSearch";
import CompletarApartado from "./pages/CompletarApartado";
import ActividadesPendientes from "./pages/ActividadesPendientes";

function AppLayout() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <div className="min-h-screen bg-surface-app">
      <Header />
      <main className={isLoginPage ? "" : "lg:pl-[260px] pt-14 lg:pt-16 min-h-screen transition-all duration-300"}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/customers" element={<CustomersTable />} />
          <Route
            path="/asignar_servicio/:id"
            element={
              <ProtectedRoute>
                <AsignarServicio />
              </ProtectedRoute>
            }
          />

          <Route
            path="/editar_solicitud/:id/:method"
            element={
              <ProtectedRoute>
                <EditarSolicitud />
              </ProtectedRoute>
            }
          />

          <Route
            path="/editar_solicitud_sin_asignar/:id/:method"
            element={
              <ProtectedRoute>
                <EditarSolicitudSinAsignar />
              </ProtectedRoute>
            }
          />

          <Route
            path="/completar_apartado/:id/:method"
            element={
              <ProtectedRoute>
                <CompletarApartado />
              </ProtectedRoute>
            }
          />

          <Route
            path="/extender_solicitud"
            element={
              <ProtectedRoute>
                <ExtenderSolicitud />
              </ProtectedRoute>
            }
          />

          <Route
            path="/archivados"
            element={
              <ProtectedRoute>
                <Archivados />
              </ProtectedRoute>
            }
          />

          <Route
            path="/actividad"
            element={
              <ProtectedRoute>
                <ActivityPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pendientes"
            element={
              <ProtectedRoute>
                <AgendarServicio />
              </ProtectedRoute>
            }
          />
          <Route
            path="/actividades_pendientes"
            element={
              <ProtectedRoute>
                <ActividadesPendientes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tecnicos"
            element={
              <ProtectedRoute>
                <Tecnicos />
              </ProtectedRoute>
            }
          />

          <Route
            path="/diagrama"
            element={
              <ProtectedRoute>
                <ComponenteGantt />
              </ProtectedRoute>
            }
          />

          <Route
            path="/overview_checadas"
            element={
              <ProtectedRoute>
                <OverviewChecadas />
              </ProtectedRoute>
            }
          />

          <Route
            path="/bonos"
            element={
              <ProtectedRoute>
                <RegistroBonos />
              </ProtectedRoute>
            }
          />

          <Route
            path="/bonos_search"
            element={
              <ProtectedRoute>
                <TicketBonosSearch />
              </ProtectedRoute>
            }
          />

          <Route
            path="/gestor_gastos"
            element={
              <ProtectedRoute>
                <GestorGastos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logistica_gruas"
            element={
              <ProtectedRoute>
                <LogisticaGruas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/aptitudes/:id"
            element={
              <ProtectedRoute>
                <AptitudesTecnicos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/competencias"
            element={
              <ProtectedRoute>
                <CompetenciasTecnicas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/panel_control_informacion"
            element={
              <ProtectedRoute>
                <PanelControlInfo />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/apartar_tecnico" 
            element={
              <ProtectedRoute>
                <ApartarTecnicoSinTicket />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
